import React from "react";

import { IconArrow } from "../Icon/IconArrow";

export const BackButton: React.FC<{
  size?: number;
  backTo?: any;
  customClassName?: any;
  color?: string;
}> = ({ size = 24, backTo = "", customClassName = "", color = "#19093A" }) => {
  return (
    <a onClick={backTo} className={`cursor-pointer ${customClassName}`}>
      <IconArrow color={color} size={size} />
    </a>
  );
};
